import { Link } from "react-router-dom";

const PageHero = ({ eyebrow, title, subtitle }) => (
  <section className="relative overflow-hidden border-b border-gray-100 bg-gradient-to-br from-gray-50 to-white">
    <div className="pointer-events-none absolute -right-20 -top-24 h-72 w-72 rounded-full bg-blue-100/40 blur-3xl" />
    <div className="relative mx-auto max-w-7xl px-5 py-16 md:px-8 md:py-20">
      <nav className="mb-4 flex items-center gap-2 text-xs text-gray-500">
        <Link to="/" className="hover:text-[#1d4ed8]">Home</Link>
        <span>/</span>
        <span className="text-[#0f2a5a]">{title}</span>
      </nav>
      <p className="eyebrow text-[#1d4ed8]">{eyebrow}</p>
      <h1 className="heading-xl mt-3 text-4xl text-[#0f2a5a] md:text-5xl">{title}</h1>
      {subtitle && (
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-gray-600 md:text-lg">
          {subtitle}
        </p>
      )}
    </div>
  </section>
);

export default PageHero;
